import React from "react";
import fb from '../../lib/firebase';
import {LojaObject} from "../../models/Loja";
import {
  IonRouterLink,
  IonPage,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle, IonHeader, IonContent, IonIcon, withIonLifeCycle
} from "@ionic/react";
import FormLoja from "./FormLojaHOC";
import {EntityList} from "../../components/EntityListNG";
import {filtrarColecao} from "../../lib/utils";
import {connect} from "react-redux";
import {AppDispatch, RootState} from "../../global.state";
import {AppState} from "../../models/app";
import {actions} from "../../lib/app";
import {home} from "ionicons/icons";

interface Props {
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[];
}

class Lojas extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props:Props) {
    super(props);

    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: [],
    };

    this.cancelListener = () => {};
  }

  componentDidMount() {
    this.installListener();
  }
  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    this.setState({loading: true});
    const query = fb.db.collection('lojas')
      .where('owner', '==', this.props.app.user.uid)
      .orderBy('nome')

    this.cancelListener = query.onSnapshot(snap => {
      const colecao = fb.col(snap).filter((l: any) => l.ativo !== false);
      this.setState({colecao, loading: false});
      this.filtrarColecao();
    });
  };

  filtrarColecao = (criterio:string='') => {
    this.setState({
      colecaoFiltrada: filtrarColecao(this.state.colecao, criterio, 'nome')
    });
  }

  onClickInstance = (instance:LojaObject) => {
    this.props.dispatch(actions.jump('/lojas'));
    this.props.history.push(`/lojas/${instance.id}/home`);
  };

  cardSubtitle = (i: LojaObject) => (
    <>
      {i.cidade} - {i.estado}
    </>
  );

  cardTitle = (i: LojaObject) => (
    <>{i.nome}</>
  );

  cardContent = (i: LojaObject) => (
    <>
      <div>{i.proprietario}</div>
      {
        i.email &&
        <div>
          <IonRouterLink href={`mailto:${i.email}`}>
            {i.email}
          </IonRouterLink>
        </div>
      }

      {
        i.telefone && <div>{i.telefone}</div>
      }
    </>
  );

  render() {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>
              Revendas e Cooperativas
            </IonTitle>
            <IonIcon
              icon={home}
              slot="primary"
              class="pr-3 text-2xl"
              onClick={() => this.props.history.push('/home')}
            />
          </IonToolbar>
        </IonHeader>
        <IonContent>
        <EntityList
          entityLabel="loja"
          colecao={this.state.colecaoFiltrada}
          loading={this.state.loading}
          filtrarColecao={this.filtrarColecao}
          addEnabled={true}
          onClickInstance={this.onClickInstance}
          cardSubTitle={this.cardSubtitle}
          cardTitle={this.cardTitle}
          cardContent={this.cardContent}
          ModelForm={FormLoja}
        />
        </IonContent>
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Lojas));
